import { getBetslipGroup } from "../../../store/state/betslip-module/betslip-module-selectors";
import { getSportsbookBettingLegs } from "@ppb/tbd-store/state/betting/sportsbook-betting/sportsbook-betting-selectors";
import { getBettingResolvers } from "../../../store/state/sportsbook-betting/betting-resolver";
import {
  createGetFailureLegIdsByCombinationGroupIdSelector,
  createGetRunnerByCombinationGroupSelector,
  getSportsbookBettingImplyRunnerFailures,
  getSportsbookBettingRunners,
} from "../../../store/state/sportsbook-betting/sportsbook-betting-selectors";
import { BetslipApplicationState } from "../../../store/state/BetslipApplicationState";
import { MapDispatchToProps, MapStateToPropsFactory } from "react-redux";
import { i18n } from "../../../helpers/i18n";
import { DispatchProps, StateProps } from "../props";
import { createNotificationsViewModelBuilder } from "./bet-builder-failure-mapper";
import { FailureContainerProps } from "./props";
import { getUnavailableBetBuilderLegIds, getUnavailableBetBuilderRunnerIds } from "../../../helpers/combinations";

export const makeMapStateToProps: MapStateToPropsFactory<
  StateProps,
  FailureContainerProps,
  BetslipApplicationState
> = () => {
  const getRunnersByCombinationGroup = createGetRunnerByCombinationGroupSelector();
  const buildNotifications = createNotificationsViewModelBuilder();
  const getTotalBetBuilderFailure = createGetFailureLegIdsByCombinationGroupIdSelector();

  const labels = {
    odds: i18n({ key: "I18N.BETSLIP.ODDS" }),
    stake: i18n({ key: "I18N.BETSLIP.STAKE" }),
    popular: i18n({ key: "I18N.BETSLIP.POPULAR" }),
    createdBets: i18n({ key: "I18N.BETSLIP.RAB" }),
  };
  const baseState = {
    odds: i18n({ key: "I18N.BETSLIP.NOT_AVAILABLE" }),
    legIds: [],
    failedLegIds: [],
    isPopular: false,
    isPackagedCreatedBets: false,
    notifications: [],
    subtitle: "",
    i18n: labels,
  };

  return (appState: BetslipApplicationState, { combinationGroup }: FailureContainerProps): StateProps => {
    const group = getBetslipGroup(appState);
    const resolvers = getBettingResolvers(group);
    const metadata = resolvers.getMetadata(appState);
    const runnerIds = getRunnersByCombinationGroup(appState, combinationGroup);
    const runners = getSportsbookBettingRunners(appState);
    const runnerFailures = getSportsbookBettingImplyRunnerFailures(appState);
    const unavailableRunnerIds = getUnavailableBetBuilderRunnerIds(combinationGroup, runners, runnerFailures);
    const metadataRunnerIds = [
      ...unavailableRunnerIds,
      ...runnerIds.filter((runnerId) => !unavailableRunnerIds.includes(runnerId)),
    ];
    const firstValidRunnerId = metadataRunnerIds.find((runnerId) => !!metadata[runnerId]);
    const validMetadata = firstValidRunnerId ? metadata[firstValidRunnerId] : null;

    if (!validMetadata) {
      return baseState;
    }

    const failures = getTotalBetBuilderFailure(appState, combinationGroup);
    const unavailableLegIds = getUnavailableBetBuilderLegIds(
      combinationGroup,
      [],
      getSportsbookBettingLegs(appState),
      runners,
      runnerFailures,
    );

    return {
      ...baseState,
      failedLegIds: [...unavailableLegIds, ...failures.filter((legId) => !unavailableLegIds.includes(legId))],
      notifications: buildNotifications(appState, runnerIds),
      subtitle: validMetadata.type === "GENERIC" ? validMetadata.eventName : validMetadata.racing.venue,
      i18n: labels,
    };
  };
};

export const mapDispatchToProps: MapDispatchToProps<DispatchProps, FailureContainerProps> = () => ({});
